import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import Helmet from 'react-helmet';
import axios from 'axios';
import { difference } from 'lodash';

import { accountRoute } from '../../../routes';
import translate from  '../../../utils/translate';
import baseUrl from  '../../../utils/baseUrl';

import connect from '../../../utils/connect';

import Spinner from '../../svg/spinner';
import Splitter from '../block/splitter';

import JuryEntry from './juryEntry';
import JuryVoteFOTD from './juryVoteFOTD';

import JuryNav from './juryNav';
import JurySticky from './jurySticky';
import { AccountJuryOther, AccountJuryMediaTitle} from './other';

import { caseFilterResponsive } from './juryHelper';

//import translate from '../../../utils/translate';
//import * as actions from '../../../actions/account';

//import css from './fotd.scss';

class AccountJuryFOTD extends Component {
	static propTypes = {
		browser: PropTypes.object.isRequired,
		dispatch: PropTypes.func.isRequired,
		users: PropTypes.object.isRequired,
	};

	constructor() {
		super();

		this.mounted = true;

		this.state = {
			waiting: true,
			showScorecard: false,
			cases: [],
		};
	}

	componentWillMount() {
		const API_URL = `${baseUrl}/api/account/jury/fotd`;
		axios.get(API_URL)
		.then((res) => {
			if (this.mounted && res.data && res.data.cases) {
				this.setState({
					...this.state,
					cases: res.data.cases,
					waiting: false,
				});
			}
		})
		.catch(() => {});
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		let scorecardExpanderClass = 'icon-plus';
		let scorecardClass = 'account-block-content account-jury__scorecard-container span14';

		if (this.state.showScorecard) {
			scorecardExpanderClass += ' icon-plus--active';
			scorecardClass += ' account-jury__scorecard-container--active';
		}

		if (this.state.waiting) {
			return this.renderWaiting();
		}

		let cases = caseFilterResponsive(this.state.cases, this.props.browser);

		return (
			<div className=''>
				<div className='account-block-content'>
					<div className='span14 account-block-content__aside account-jury__head'>
						{this.state.cases.length} projects up for voting
					</div>

					<div className='cf'></div>

					<JurySticky browser={this.props.browser} className='account-jury__sticky' update={this.state.showScorecard}>
						<div className='span5 span5-tablet span14-mobile account-jury__col1 account-jury__subhead account-jury__subhead--first'>
							<JuryNav users={this.props.users} />
						</div>

						<div className='hide-tablet hide-mobile account-jury__col2'></div>

						<div className='span9-tablet span14-mobile account-jury__col3 account-jury__subhead'>
							<ol>
								<li onClick={() => this.toggleScorecard()}>
									Scorecard <span className={scorecardExpanderClass}></span>
								</li>
							</ol>
						</div>
						<div className='cf'></div>

						<div className={scorecardClass}>
							<div className='span5 span5-tablet hide-mobile account-jury__col1'></div>
							<div className='span9-tablet span14-mobile account-jury__col2 account-jury__scorecard__intro'>
								<p dangerouslySetInnerHTML={{ __html: translate('account/jury/fotd') }}></p>
							</div>

							<div className='span9-tablet span14-mobile push5-tablet account-jury__col3 account-jury__col3--scorecard'>
								<ol className='account-jury__scorecard'>
									<li className='account-jury__scorecard__item account-jury__scorecard__item--green'>
										<em>{translate('account/jury/scoreInterval1')}</em> {translate('account/jury/score9000')}
									</li>
									<li className='account-jury__scorecard__item account-jury__scorecard__item--green'>
										<em>{translate('account/jury/scoreInterval2')}</em> {translate('account/jury/score8089')}
									</li>
									<li className='account-jury__scorecard__item account-jury__scorecard__item--green'>
										<em>{translate('account/jury/scoreInterval3')}</em> {translate('account/jury/score7079')}
									</li>
									<li className='account-jury__scorecard__item account-jury__scorecard__item--orange'>
										<em>{translate('account/jury/scoreInterval4')}</em> {translate('account/jury/score4169')}
									</li>
									<li className='account-jury__scorecard__item account-jury__scorecard__item--red'>
										<em>{translate('account/jury/scoreInterval5')}</em> {translate('account/jury/score2040')}
									</li>
									<li className='account-jury__scorecard__item'>
										<em>{translate('account/jury/scoreInterval6')}</em> {translate('account/jury/score0019')}
									</li>
									<li className='account-jury__scorecard__item'>
										<em>{translate('account/jury/scoreInterval7')}</em> {translate('account/jury/score0050')}
									</li>
								</ol>
							</div>

							<div className='cf'></div>
						</div>
					</JurySticky>
				</div>

				<Splitter />

				{(this.props.browser.window.width < 1200) && (
					<AccountJuryMediaTitle browser={this.props.browser} caseCount={cases.length} />
				)}

				{cases.map((item) => (
					<JuryEntry
						key={item.id}
						item={item}
						browser={this.props.browser}
						dispatch={this.props.dispatch}
						component={JuryVoteFOTD}
						hideAfterSubmit
						removeItemCB={() => this.removeCase(item)}
					/>
				))}

				{(this.props.browser.window.width < 1200) && (
					<AccountJuryOther browser={this.props.browser} dispatch={this.props.dispatch} allCases={this.state.cases} cases={cases} />
				)}

			</div>
		);
	}

	removeCase(item) {
		this.setState({
			...this.state,
			cases: difference(this.state.cases, [item]),
		});
	}

	toggleScorecard() {
		this.mounted && this.setState({
			...this.state,
			showScorecard: !this.state.showScorecard,
		});
	}

	renderWaiting() {
		return (
			<div key='spinner' style={{ textAlign: 'center', width: '100%', marginTop: '50px' }}>
				<Spinner size='60' />
			</div>
		);
	}
}

export default connect(AccountJuryFOTD);



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jury/fotd.js
 **/